// src/pages/CmsPaymentsModal.jsx
import React, { useMemo, useState } from "react";

export default function PaymentsModal({ open, onClose, rows = [], pageSize = 10, fmtKRW, onlyDate }) {
  const [page, setPage] = useState(1);
  const total = rows.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = (page - 1) * pageSize;
  const pageRows = useMemo(() => rows.slice(start, start + pageSize), [rows, start, pageSize]);

  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-[100]" onClick={onClose} />
      <div className="fixed z-[110] inset-0 grid place-items-center p-4">
        <div className="w-full max-w-3xl rounded-xl bg-white shadow-xl">
          <div className="flex items-center justify-between px-4 py-3 border-b">
            <h3 className="text-base font-semibold">결제 내역 전체</h3>
            <button className="text-sm text-neutral-600 hover:text-black" onClick={onClose}>닫기</button>
          </div>

          <div className="p-4">
            <table className="w-full table-fixed text-sm">
              <colgroup>
                <col className="w-20"/><col className="w-36"/><col className="w-24"/>
                <col className="w-24"/><col className="w-28"/><col className="w-28"/>
              </colgroup>
              <thead className="bg-neutral-50 text-neutral-500">
                <tr>
                  <th className="px-3 py-2 text-center">상태</th>
                  <th className="px-3 py-2 text-left">상품명</th>
                  <th className="px-3 py-2 text-center">스토어</th>
                  <th className="px-3 py-2 text-right">금액</th>
                  <th className="px-3 py-2 text-center">결제일</th>
                  <th className="px-3 py-2 text-center">다음 갱신일</th>
                </tr>
              </thead>
              <tbody>
                {pageRows.length ? pageRows.map(p => (
                  <tr key={p.payment_id} className="border-b">
                    <td className="px-3 py-2 text-center">{p.is_valid ? "구독중" : "만료"}</td>
                    <td className="px-3 py-2">{p.ticket_name || "-"}</td>
                    <td className="px-3 py-2 text-center">{p.store || "Google play"}</td>
                    <td className="px-3 py-2 text-right">{fmtKRW ? fmtKRW(p.ticket_price) : p.ticket_price}</td>
                    <td className="px-3 py-2 text-center">{onlyDate ? onlyDate(p.payment_date) : p.payment_date}</td>
                    <td className="px-3 py-2 text-center">{onlyDate ? (onlyDate(p.next_renewal) || "기간 없음") : p.next_renewal}</td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan={6} className="px-3 py-8 text-center text-neutral-500">
                      결제 내역이 없습니다.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* pager */}
            {totalPages > 1 && (
              <div className="flex items-center justify-center gap-2 mt-4">
                <button
                  className="px-2 py-1 text-sm rounded-lg border border-gray-200 hover:bg-gray-100 disabled:opacity-50"
                  onClick={() => setPage(p => Math.max(1, p - 1))}
                  disabled={page === 1}
                >
                  이전
                </button>
                {Array.from({ length: totalPages }).map((_, i) => (
                  <button
                    key={i}
                    className={`w-8 h-8 rounded-lg text-sm border transition ${page === i + 1 ? "bg-[#7864F9] text-white" : "border-gray-200 hover:bg-gray-100"}`}
                    onClick={() => setPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}
                <button
                  className="px-2 py-1 text-sm rounded-lg border border-gray-200 hover:bg-gray-100 disabled:opacity-50"
                  onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                  disabled={page === totalPages}
                >
                  다음
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
